import { getSubVerticalByPath } from 'common/constants'

const SET = 'subVerticalByPathname/SET'

// component render 도중 값이 변경되면 안되므로, 최종 route action 에서만 호출해야 합니다. 호출 필요 시 최효석 에게 문의바랍니다.
export const setSubVerticalByPathname = (pathname = '') => {
  return {
    subVertical: getSubVerticalByPath(pathname),
    type: SET,
  }
}

export default (state = false, action) => {
  switch (action.type) {
    case SET:
      return action.subVertical
    default:
      return state
  }
}
